import { useState } from 'react';
export function useCountStepper(props) {
    const { defaultValue = 0, onOverLimit = console.log, disableIncrease = false, disableDecrease = false, disable = false, min, max, } = props;
    const [editingValue, setEditingValue] = useState(defaultValue);
    const isDecreaseDisabled = editingValue <= min || disableDecrease || disable;
    const isIncreaseDisabled = editingValue >= max || disableIncrease || disable;
    function onChange(val) {
        var _a;
        setEditingValue(val);
        (_a = props === null || props === void 0 ? void 0 : props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, val);
    }
    function onMinus(val) {
        var _a;
        (_a = props === null || props === void 0 ? void 0 : props.onMinus) === null || _a === void 0 ? void 0 : _a.call(props, val);
        onChange === null || onChange === void 0 ? void 0 : onChange(val);
    }
    function onPlus(val) {
        var _a;
        (_a = props === null || props === void 0 ? void 0 : props.onPlus) === null || _a === void 0 ? void 0 : _a.call(props, val);
        onChange === null || onChange === void 0 ? void 0 : onChange(val);
    }
    function decrease() {
        if (disable)
            return;
        if (editingValue > max) {
            onMinus(Number(max)); // 初始值大于max值时，点击-按钮，直接减少到max值
            return;
        }
        if (!isDecreaseDisabled)
            onMinus(Number(editingValue) - 1);
        else
            onOverLimit('minus');
    }
    function increase() {
        if (disable)
            return;
        if (!isIncreaseDisabled)
            onPlus(Number(editingValue) + 1);
        else
            onOverLimit('plus');
    }
    function handleBlur() {
        let val = Number(editingValue);
        if (Number.isNaN(val))
            val = 1;
        else if (val > max) {
            val = max;
            // onOverLimit('plus');
        }
        else if (val < min) {
            val = min;
            onOverLimit('minus');
        }
        if (editingValue === val)
            return;
        onChange(val);
    }
    function handleChange(text) {
        if (text) {
            let val = Number(text);
            // 如果输入的不是数字， 则不让输入，即回退到上一次输入的结果
            if (Number.isNaN(val)) {
                return;
            }
            else if (val > max) {
                onOverLimit(val);
                val = max;
            }
            else if (val < min) {
                onOverLimit(val);
                val = min;
            }
            if (editingValue === val)
                return;
            onChange(val);
        }
        else {
            // 如果为空，展示未空，但是不触发onChange
            if (+text < min) {
                onChange(min);
            }
        }
    }
    return {
        editingValue,
        isDecreaseDisabled,
        isIncreaseDisabled,
        handleBlur,
        handleChange,
        increase,
        decrease,
    };
}
